import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%20beautiful%20illustration%20dreamy%20atmosphere%20starry%20night%20sky%20soft%20gradient%20warm%20coral%20and%20cream%20tones%20elegant%20character%20silhouette%20magical%20particles%20flowing%20ink%20effect%20artistic%20webtoon%20background%20subtle%20texture%20minimalist%20composition%20ethereal%20lighting&width=1800&height=800&seq=hero-bg-main&orientation=landscape"
        alt="韩漫在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full px-4 md:px-6 flex items-center">
        <div className="w-full max-w-2xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight">
            韩漫在线观看
          </h1>
          <p className="mt-4 md:mt-5 text-base md:text-lg text-white/80 max-w-lg leading-relaxed">
            免费漫画下拉式阅读体验，智能预加载技术确保极速流畅浏览。从甜蜜恋爱到热血奇幻，全类型韩漫尽在掌握。
          </p>
          <div className="mt-6 md:mt-7 flex flex-col sm:flex-row gap-3">
            <Link
              to="/category/romance"
              className="px-7 py-3 bg-primary-500 text-white rounded-full text-sm font-semibold text-center hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
            >
              立即阅读
            </Link>
            <Link
              to="/category/fantasy"
              className="px-7 py-3 bg-white/15 text-white backdrop-blur-sm rounded-full text-sm font-semibold text-center hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap"
            >
              热门分类
            </Link>
          </div>
          <div className="mt-6 md:mt-8 flex flex-wrap gap-3 md:gap-4">
            {['每日更新', '高清画质', '下拉式阅读', '智能预加载'].map((feat) => (
              <span key={feat} className="flex items-center gap-1.5 text-xs md:text-sm text-white/70">
                <i className="ri-check-line w-4 h-4 flex items-center justify-center"></i>
                {feat}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}